export default __webpack_public_path__ + "static/media/start.f08cd545.svg";